module.exports = __webpack_public_path__ + "static/media/img-talent-profile-top@2x.9e259dfd.png";